export default "__VITE_ASSET__JZoIVQNU__"